export default {
  settings: {
    title: "Einstellungen",
    subtitle: "Verwalte dein Konto und deine Einstellungen",
    nav: {
      profile: "Mein Profil & Partner",
      wedding: "Hochzeitsdetails",
      event: "Veranstaltungsdetails",
      collaborators: "Mitarbeiter",
      notifications: "Benachrichtigungen",
      appearance: "Aussehen & Sprache",
      subscription: "Abonnement",
      security: "Sicherheit"
    },
    groups: {
      account: "Konto",
      event: "Veranstaltung",
      preferences: "Einstellungen"
    },
    general: {
      title: "Mein Profil & Partner",
      description: "Verwalte deine persönlichen Daten und die deines Partners.",
      me: "Ich",
      partner: "Mein Partner",
      partnerHelp: "Lade deinen Partner ein, um bei der Hochzeitsplanung mitzuwirken."
    },
    wedding: {
      title: "Hochzeitsdetails",
      description: "Wichtige Informationen zu deiner Veranstaltung."
    },
    appearance: {
      title: "Aussehen & Sprache",
      description: "Passe deine Erfahrung an.",
      languages: {
        fr: "Französisch",
        en: "Englisch",
        es: "Spanisch",
        de: "Deutsch",
        it: "Italienisch"
      }
    },
    notifications: {
      email: {
        title: "E-Mail-Benachrichtigungen",
        description: "Erhalten Sie wichtige Updates und Erinnerungen per E-Mail"
      },
      push: {
        title: "Push-Benachrichtigungen",
        description: "Erhalten Sie Echtzeit-Warnungen in Ihrem Browser"
      },
      title: "Benachrichtigungen",
      description: "Wähle, wie und wann du benachrichtigt werden möchtest.",
      enable: "Benachrichtigungen aktivieren",
      enableDesc: "Erhalte Benachrichtigungen für wichtige Ereignisse",
      types: "Benachrichtigungstypen",
      reminderTiming: "Standard-Erinnerungszeit",
      hoursBefore: "{{count}} Std. vorher",
      quietHours: "Ruhezeiten",
      start: "Start",
      end: "Ende",
      labels: {
        tasks: "Aufgaben",
        guests: "Gäste",
        budget: "Budget",
        system: "System"
      },
      error: "Fehler beim Laden der Benachrichtigungseinstellungen"
    },
    security: {
      title: "Sicherheit",
      description: "Verwalte dein Passwort und deine Sitzungen.",
      status: "Kontostatus",
      verified: "Deine E-Mail ist bestätigt.",
      unverified: "Deine E-Mail ist nicht bestätigt.",
      sessions: "Aktive Sitzungen",
      dangerZone: "Gefahrenzone",
      deleteAccount: "Konto löschen",
      deleteAccountHelp: "Diese Aktion kann nicht rückgängig gemacht werden."
    },
    collaborators: {
      title: "Freigabeverwaltung",
      invitationsTitle: "Freigabeeinladungen",
      noWedding: "Keine Hochzeit gefunden",
      loadError: "Beim Laden der Hochzeit ist ein Fehler aufgetreten",
      invitationsError: "Beim Laden der Einladungen ist ein Fehler aufgetreten",
      noInvitations: "Keine Einladungen gefunden",
      noInvitationsDesc: "Freigabeeinladungen werden hier angezeigt, sobald sie erstellt wurden",
      expiresAt: "Läuft ab am: {{date}}",
      accessCode: "Zugangscode: {{code}}",
      infoMessage: "Diese Seite zeigt gesendete Freigabeeinladungen an. Um neue Einladungen zu erstellen oder Mitarbeiter zu verwalten, verwenden Sie die ShareManagement-Komponente in Ihren Veranstaltungseinstellungen.",
      status: {
        pending: "Ausstehend",
        accepted: "Akzeptiert",
        declined: "Abgelehnt",
        expired: "Abgelaufen"
      },
      resourceTypes: {
        tasks: "Aufgaben",
        guests: "Gäste",
        budget: "Budget",
        timeline: "Zeitplan",
        tasksAndGuests: "Aufgaben und Gäste"
      }
    },
    subscription: {
      title: "Abonnement & Abrechnung",
      description: "Verwalte deinen Plan und verfolge deine Nutzung.",
      invoices: "Rechnungen",
      noInvoices: "Keine Rechnungen verfügbar",
      upgrade: "Upgrade auf Premium",
      features: {
        oneEvent: "1 Veranstaltung",
        basicGuests: "Einfache Gästeliste",
        limitedTasks: "Begrenzte Aufgaben",
        unlimitedEvents: "Unbegrenzte Veranstaltungen",
        unlimitedGuests: "Unbegrenzte Gäste",
        export: "PDF- & Excel-Export",
        seating: "Erweiterter Sitzplan",
        budget: "Budget & Analysen",
        support: "Priorisierter Support"
      },
      proDescription: "Genieße alle Funktionen ohne Einschränkungen.",
      freeDescription: "Upgrade auf Premium, um alle Funktionen freizuschalten."
    },
    theme: "Thema",
    placeholders: {
      exampleName: "Bsp: Anna Müller",
      exampleVenue: "Bsp: Grand Hotel"
    },
    language: "Sprache",
    languageDescription: "Wählen Sie die Sprache der Benutzeroberfläche",
    account: {
      export: {
        button: "Meine Daten exportieren",
        loading: "Export läuft..."
      },
      errors: {
        exportData: "Fehler beim Exportieren der Daten",
        deleteAccount: "Fehler beim Löschen des Kontos"
      }
    },
    export: {
      title: "Meine Daten exportieren",
      description: "Laden Sie eine Kopie aller Ihrer Daten herunter (Gäste, Aufgaben, Budget usw.)",
      gdprNotice: "Gemäß der DSGVO können Sie alle Ihre persönlichen Daten abrufen."
    },
    delete: {
      title: "Mein Konto löschen",
      description: "Diese Aktion ist irreversibel. Alle Ihre Daten werden dauerhaft gelöscht.",
      confirmTitle: "Mein Konto löschen?",
      confirmDescription: "Sind Sie sicher, dass Sie Ihr Konto dauerhaft löschen möchten? Alle Ihre Daten gehen verloren.",
      confirmButton: "Dauerhaft löschen"
    },
    firstName: "Vorname",
    lastName: "Nachname",
    email: "E-Mail",
    partnerName: "Vollständiger Name",
    partnerEmail: "E-Mail (für Einladung)",
    weddingDate: "Hochzeitsdatum",
    location: "Ort & Lage",
    venue: "Empfangsort",
    country: "Land",
    city: "Stadt",
    guestCount: "Geschätzte Gästeanzahl",
    password: "Passwort",
    passwordHelp: "Zuletzt geändert vor 3 Monaten",
    changePassword: "Ändern",
    currentPassword: "Aktuelles Passwort",
    newPassword: "Neues Passwort"
  }
};